export default function initAnimation() {
  const animations = [
    'fade',
    'fade-up',
    'fade-down',
    'fade-left',
    'fade-right',
    'fade-up-right',
    'fade-up-left',
    'fade-down-right',
    'fade-down-left',
    'flip-left',
    'flip-right',
    'flip-up',
    'flip-down',
    'slide-up',
    'slide-down',
    'slide-left',
    'slide-right',
    'zoom-in',
    'zoom-in-up',
    'zoom-in-down',
    'zoom-in-left',
    'zoom-in-right',
    'zoom-out',
    'zoom-out-up',
    'zoom-out-down',
    'zoom-out-left',
    'zoom-out-right',
  ];

  animations.forEach((type) => {
    document.querySelectorAll(`.${type}`).forEach((el) => {
      el.setAttribute('data-aos', type);
      // el.setAttribute('data-aos-duration', '800');
      // el.setAttribute('data-aos-delay', '100');
      // el.setAttribute('data-aos-offset', '120');
      // el.setAttribute('data-aos-once', 'true');
      // el.setAttribute('data-aos-easing', 'ease-in-out');
    });
  });
}
